/**
 * Constructs the full URL for a user profile picture
 * @param {string} userPicFilename - The user_pic_filename from user object (e.g., "/users/5/profile-1764410834322.jpeg")
 * @returns {string|null} - The full URL to access the profile picture, or null if no filename
 */
export const getProfilePictureUrl = (userPicFilename) => {
    // Return null if no filename provided or if it's an empty string
    if (!userPicFilename || userPicFilename.trim() === '') {
        return null;
    }

    const baseUrl = process.env.REACT_APP_AUTH_BASE_URL || 'https://login.foipin.com';

    // If the filename already contains the full URL, return it as is
    if (userPicFilename.startsWith('http://') || userPicFilename.startsWith('https://')) {
        return userPicFilename;
    }

    // Construct the full URL: baseUrl + /files + userPicFilename
    // Remove leading slash from userPicFilename if present to avoid double slashes
    const cleanFilename = userPicFilename.startsWith('/') ? userPicFilename : `/${userPicFilename}`;

    const fullUrl = `${baseUrl}/files${cleanFilename}`;

    console.log('Profile Picture URL:', fullUrl); // Debug log

    return fullUrl;
};
